
<el-row :gutter="0" class="header">
  <el-col class="part-first" :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
    <el-row>
      <el-col class="part-first-1" :xs="11" :sm="11" :md="11" :lg="11" :xl="11" align="left">
        <div id="logoToPrint" class="header-logo header-btn" @click="resetApp"></div>
      </el-col>
      <el-col class="part-first-2" :xs="11" :sm="11" :md="11" :lg="11" :xl="11" align="center">
        <el-badge :value="nbUnconfirmedResaLenght" :hidden="nbUnconfirmedResaLenght <= 0" class="item">
          <el-popover placement="bottom" :disabled="getNotifDisable" width="383" trigger="click" v-model="popupNotif"
            popper-class="header-notif-popup">
            <div class="header-notif-scrollable" :style="{ height: (getUnConfirmedResa.length * 88) + 30 + 'px' }">
              <div class="header-notif-container">
                <resa-notif v-for="resa in getUnConfirmedResa" :key="resa.id" :resa="resa"
                  v-on:bubleclose="popupNotif = false"></resa-notif>
              </div>
            </div>
            <div slot="reference" class="header-btn">
              <div class="header-notif"></div>
            </div>
          </el-popover>
        </el-badge>
      </el-col>
      <el-col class="mobile-hide" :xs="2" :sm="2" :md="2" :lg="2" :xl="2" align="center">
        <div class="header-separator"></div>
      </el-col>
      <el-col class="part-first-3" :xs="2" :sm="0" :md="0" :lg="0" :xl="0" align="center">
        <div class="header-btn" @click="clickPopupTakeResa">
          <div class="header-booking"></div>
        </div>
      </el-col>
    </el-row>
  </el-col>
  <el-col class="part-second" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
    <calendar-nav />
  </el-col>
  <el-col class="part-second" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
    <services-nav />
  </el-col>
  <el-col class="part-second mobile-show-header" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
    <room-nav />
  </el-col>
  <el-col class="part-third" :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
    <el-row>
      <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" align="center">
        <div class="header-separator"></div>
      </el-col>
      <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22" align="center">
        <div class="header-btn" @click="clickPopupTakeResa">
          <div class="header-booking"></div>
        </div>
      </el-col>
    </el-row>
  </el-col>
</el-row>
